import ApplicationController from './application_controller';

// Connects to data-controller="auto-scroll"
export default class extends ApplicationController {
  connect() {
    super.connect();
  }

  scroll() {
    this.element.scrollIntoView({ behavior: 'smooth' });
  }
}
